__turbopack_context__.v({
  "fullWidthModalField": "styles-module-scss-module__Mi_x9q__fullWidthModalField",
  "modalBody": "styles-module-scss-module__Mi_x9q__modalBody",
  "modalContainer": "styles-module-scss-module__Mi_x9q__modalContainer",
  "modalField": "styles-module-scss-module__Mi_x9q__modalField",
  "modalFieldComment": "styles-module-scss-module__Mi_x9q__modalFieldComment",
  "modalFooter": "styles-module-scss-module__Mi_x9q__modalFooter",
  "modalHeader": "styles-module-scss-module__Mi_x9q__modalHeader",
  "modalRecaptchaField": "styles-module-scss-module__Mi_x9q__modalRecaptchaField",
  "modalRow": "styles-module-scss-module__Mi_x9q__modalRow",
  "modalSubmitButton": "styles-module-scss-module__Mi_x9q__modalSubmitButton",
  "solutionsGroup": "styles-module-scss-module__Mi_x9q__solutionsGroup",
  "solutionsRow": "styles-module-scss-module__Mi_x9q__solutionsRow",
});
